// @ts-nocheck
import { useSelector } from 'react-redux';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../../utils/LocalStorage';
import { Fragment, useEffect, useState } from 'react';
import { notification } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './AppVersion.module.scss';

const AppVersion = () => {
    const appVersion = useSelector(state => state.global.appVersion);

    const [notificationId, setNotificationId] = useState(null);

    useEffect(() => {
        const currentAppVersion = LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion);

        if (currentAppVersion !== appVersion) {
            showNewVersionNotification();
        } else {
            notification.close(notificationId);
            setNotificationId(null);
        }
    }, [appVersion]);

    const showNewVersionNotification = () => {
        if (notificationId) {
            notification.close(notificationId);
        }

        const newNotificationId = new Date().getTime();

        notification.open({
            key: newNotificationId,
            className: styles.notification,
            closeIcon: <Fragment />,
            duration: 0,
            description: (
                <div className={`flex justify-between align-center p-x-6 p-y-6 f-s-14`}>
                    <div className={`flex justify-between align-center`}>
                        <InfoCircleOutlined className={`${styles.notificationIcon} f-s-20`} />
                        <span className={'p-l-4'}>New version is available</span>
                    </div>
                    <span className={`${styles.notificationAction} cursor-pointer p-x-4 p-y-2`} onClick={refreshPage}>
                        Reload
                    </span>
                </div>
            ),
        });

        setNotificationId(newNotificationId);
    };

    const refreshPage = () => {
        window.location.reload();
        LocalStorage.setItem(LOCAL_STORAGE_KEYS.appVersion, appVersion);
    };

    return null;
};

export default AppVersion;
